import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, RequestMethod } from '@angular/http';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { catchError, map } from 'rxjs/operators';
import 'rxjs/add/observable/throw';
import { environment } from '../environments/environment';
import { tap } from 'rxjs/operators';
import { Subject } from 'rxjs';

export class Message {
  constructor(public author: string, public content: string) {}
}

@Injectable({
  providedIn: 'root'
})
export class AjaxService {

  constructor( private http:Http, private httpClient:HttpClient ) { }
  


  public ajaxpost(data:any,method:any, url:any) {
    var obj = {
      submitUrl: url,
      data:data,
      dataType: "JSON",  
      method :method  
    }
    return this.httpClient.post(environment.api_url + obj.submitUrl, obj.data,
      { 
        headers :{  
        
        } 
      }
      )
    .map(response => response)
    .catch(this._errorhandler);
  }
    
  public adddownloadform(data:any, url:any) {
    return this.httpClient.post(environment.api_url +url, data)
  } 
  public getsubmittedtowervalue(data:any, url:any) {
    return this.httpClient.post(environment.api_url +url, data)
  }

 


  private _errorhandler(error: Response){
    console.error(error);
    return Observable.throw(error || "some error occured");
  }
}    